import { string_utilities, misc_utilities } from "../nibnut/mixins"

const addl_string_utilities = {
    mixins: [string_utilities, misc_utilities],
    methods: {
        slugify (string, space_replacement) {
            if(!string) return string
            return string.toLowerCase().replace(/[^a-zA-Z\-0-9]/g, space_replacement || "-")
        },
        date_string (date) {
            return this.$moment(date).fromNow()
        },
        formatted_date_string (date, format) {
            if(!date) return ""
            return this.$moment(date).format(format || "YYYY-MM-DD")
        },
        formatted_time_string (date, format) {
            if(!date) return ""
            return this.$moment(date).format(format || "h:mm A")
        },
        formatted_duration_string (duration) {
            return this.$moment.duration(duration).humanize()
        },
        formatted_dates_duration_string (start_date, end_date) {
            return this.formatted_duration_string(this.$moment(start_date).diff(this.$moment(end_date)))
        },
        number_string (number, format, default_value) {
            if(!number && default_value) return default_value
            return this.$numeral(number).format(format || "0,0.0")
        },
        number_field_value (editable, number, format, default_value) {
            if(editable) return number
            return this.number_string(number, format, default_value)
        },
        monetary_symbol (country_code) {
            if(country_code === "GB") return "£"
            return "$"
        },
        monetary_glyph (country_code) {
            if(country_code === "GB") return "pound-sign"
            return "dollar-sign"
        },
        monetary_glyph_position (country_code) {
            // if(country_code === "CA") return "right"
            return "left"
        },
        currency_string (country_code, number, format, force_as_amount) {
            if(!number && !force_as_amount) return this.$root.translate("Free")
            const amount = this.number_string(number, format || "0,0.00")
            const symbol = this.monetary_symbol(country_code)
            if(this.monetary_glyph_position(country_code) === "right") return `${amount} ${symbol}`
            return `${symbol} ${amount}`
        },
        phone (phone) {
            if(!phone) return ""
            const matches = phone.match(/^(\d{3})(\d{3})(\d{4})$/)
            if(matches) return `(${matches[1]}) ${matches[2]}-${matches[3]}`
            return ""
        },
        mailto (email) {
            if(!email) return ""
            return "mailto:" + email
        },
        telto (email) {
            if(!email) return ""
            return "tel:" + email
        },
        ucwords (text) {
            if(!text) return text
            return text.replace(/(?:^\w|[A-Z]|\b\w)/g, (letter) => {
                return letter.toUpperCase()
            })
        },
        auto_truncate (text, max_length, ellipsis) {
            const length = text.length
            if(length <= max_length) return text
            ellipsis = ellipsis || "..."
            return text.substring(0, max_length - ellipsis.length) + ellipsis
        },
        task_type_data (task_type) {
            if(!this.$root.task_type_infos) return null
            return this.$root.task_type_infos[task_type]
        },
        cost_type_name (cost_type) {
            return this.ucwords(cost_type.replace(/_/g, " "))
        }
    }
}

export default addl_string_utilities
